import {
  API, GET, POST, PATCH, DELETE,
} from '../middleware/api';
import { API_URL } from '../config';

// Toimipisteet of one organization. Every call names the organization: the
// backend authorises fleet admins/managers and the serving chain's admins/managers.

export function fetchBusinessUnits(organizationId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/business_unit/`,
      types: [
        'FETCH_BUSINESS_UNITS_REQUEST',
        'FETCH_BUSINESS_UNITS_SUCCESS',
        'FETCH_BUSINESS_UNITS_FAIL',
      ],
      params: { organization_id: organizationId },
    },
  };
}

export function createBusinessUnit(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/business_unit/`,
      types: [
        'CREATE_BUSINESS_UNIT_REQUEST',
        'CREATE_BUSINESS_UNIT_SUCCESS',
        'CREATE_BUSINESS_UNIT_FAIL',
      ],
      data,
      params: { organization_id: data.organization },
    },
  };
}

export function updateBusinessUnit(businessUnitId, data, organizationId) {
  return {
    [API]: {
      method: PATCH,
      url: `${API_URL}/uiapi/1/business_unit/${businessUnitId}/`,
      types: [
        'UPDATE_BUSINESS_UNIT_REQUEST',
        'UPDATE_BUSINESS_UNIT_SUCCESS',
        'UPDATE_BUSINESS_UNIT_FAIL',
      ],
      data,
      params: { organization_id: organizationId },
    },
  };
}

export function deleteBusinessUnit(businessUnitId, organizationId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/business_unit/${businessUnitId}/`,
      types: [
        'DELETE_BUSINESS_UNIT_REQUEST',
        'DELETE_BUSINESS_UNIT_SUCCESS',
        'DELETE_BUSINESS_UNIT_FAIL',
      ],
      additionalData: {
        itemId: businessUnitId,
      },
      params: { organization_id: organizationId },
    },
  };
}
